<template>
  <div class="app-wrap">
    <transition :name="transitionName">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition :name="transitionName">
      <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
    </transition>
    <toast
      :open="toastVisible"
      :delay="false"
      :commitFlag="toastFlag"
      @close="closeToast"
    >
      <span slot="tipmes" class="toastText">{{ toastMes }}</span>
    </toast>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from "vue";
import toast from "@/components/feedback/toast";
import { wxShare, getSystemInfo } from "@/mock/mock";
// UI框架相关
import Button from "@nutui/nutui/dist/packages/button/button.js";
import TextInput from "@nutui/nutui/dist/packages/textinput/textinput.js";
import swiper from "@nutui/nutui/dist/packages/swiper/swiper.js";
import toastNui from "@nutui/nutui/dist/packages/toast/toast.js";
import { GoPage } from '@/utils/goPage'
import "@nutui/nutui/dist/packages/button/button.css";
import "@nutui/nutui/dist/packages/textinput/textinput.css";
import "@nutui/nutui/dist/packages/swiper/swiper.css";
import "@nutui/nutui/dist/packages/toast/toast.css";
Button.install(Vue);
TextInput.install(Vue);
swiper.install(Vue);
toastNui.install(Vue);

export default {
  name: "app",
  provide () {
    return {
      reload: this.reload,
    };
  },
  data () {
    return {
      transitionName: "slide-left",
      toastVisible: !1,
      toastMes: "",
      toastFlag: !1,
      isRouterAlive: true,
    };
  },
  created () {
    const message = {
      show: this.showToast,
      close: this.closeToast,
    };
    Vue.prototype.toast = message;
    const goPage = new GoPage(this)
    Vue.prototype.$go = goPage
    Vue.prototype.handleScroll = this.$utils.debounce(this.handleScroll, 500).bind(this)
    this.getSystemInfo();
  },
  mounted () {
    this.initWxShare();
    console.log("router参数", this.$route.path);
    console.log("url参数", window.location.href);
  },
  methods: {
    handleScroll (pageKey, page) {
      zhuge.track("ScrollUp", {
        page_key: pageKey,
        page: page || 0
      })
    },
    /** 获取系统参数 */
    async getSystemInfo() {
      const res = await getSystemInfo();
      if (res.data.code === "200") {
        Vue.prototype.numScaleMapPower = res.data.data.numScaleMap.power || 2;
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    closeToast () {
      this.toastMes = "";
      this.toastVisible = !1;
    },
    showToast (mes, toastFlag, delay = 1000) {
      this.toastFlag = toastFlag || !1;
      console.log(toastFlag, this.toastFlag);
      this.toastMes = mes;
      this.toastVisible = !0;
      return new Promise((resolve, reject) => {
        this.delay && clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.toastMes = "";
          this.toastVisible = !1;
          resolve();
          clearTimeout(this.delay);
        }, delay);
      });
    },
    async initWxShare() {
      const resp = await wxShare({
        url: window.location.href.split("#")[0]
      });
      const { timestamp, nonceStr, signature, appid } = resp.data.data;
      console.log("微信返回参数", resp.data.data);
      this.$wx.config({
        debug: false,
        appId: appid,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "onMenuShareQZone",
          "hideMenuItems",
          "getLocation",
        ],
        openTagList: ["wx-open-launch-weapp"],
      });
      this.$wx.error((res) => {
        console.log(JSON.stringify(res));
      });
    },
  },
  components: {
    toast,
  },
  watch: {
    //使用watch 监听$router的变化
    $route (to, from) {
      // 有主级到次级
      if (to.meta.index > from.meta.index) {
        this.transitionName = "slide-left"; // 向左滑动
      } else if (to.meta.index < from.meta.index) {
        // 由次级到主级
        this.transitionName = "slide-right";
      } else {
        this.transitionName = ""; //同级无过渡效果
      }
    },
  },
};
</script>

<style rel="stylesheet/stylus" lang="stylus">
@import 'assets/css/index.styl'
body
  // font-family: PingFangSC-Light,helvetica,Heiti SC;
  font-family '苹方-简', helvetica, 'Heiti SC' !important
  position relative
  .app-wrap
    // background-color #ffffff
    position absolute
    width 100%
    top 0
    left 50%
    margin-left -50%
    height 100%
    box-shadow 0 0 rpx(4) rgba(0, 0, 0, 0.6)
    .toastText
      width 100%
      white-space normal
      word-break break-all
</style>



// WEBPACK FOOTER //
// src/starcharge/app.vue